<template>
    <el-button
        v-bind="$attrs"
        type="primary"
        native-type="submit"
        :disabled="disabled || lqForm.isSubmiting"
        :loading="lqForm.isSubmiting"
    >{{ !lqForm.isSubmiting ? (label ? label : 'Submit'): 'Requesting...' }}</el-button>
</template>

<script>
export default {
    name: 'lq-el-submit',
    props: {
        label: String,
        disabled: Boolean
    },
    inject: ['lqForm']
};
</script>

